<div class="modal-header-custom d-flex flex-row">
  <mat-icon (click)="close()" class="close">close</mat-icon>
</div>

<mat-dialog-content style="max-height: 87vh;">
  <div class="d-flex flex-row justify-content-between">
    <div class="d-flex flex-row align-items-center">
    <img
      alt="venue-placeholder"
      [src]="venueItem?.pictureUrl ? venueItem?.pictureUrl : './assets/images/icons/venue-logo-placeholder-01.svg'"
    >
    <div>
      <div class="d-flex flex-row">
        <span style="color:white; font-weight:900">{{venueItem?.name}}</span>
      </div>
      <div style="font-size: 12px;" class="d-flex flex-row">
        <a class="weburl" href="{{venueItem?.websiteUrl}}" target="_blank">{{venueItem?.websiteUrl}}</a>
      </div>
    </div>
  </div>
  <div class="d-flex flex-column align-items-center me-4">
    <label>{{ 'VENUES.GEOFENCE' | translate }}</label>
    <span>{{(venueItem?.sendLocationNotifications == true ? 'VENUES.GEOFENCING.ON' : 'VENUES.GEOFENCING.OFF') | translate}}</span>
  </div>
  </div>

  <mat-horizontal-stepper>
    <mat-step>
      <div *ngIf="!loading" class="row info">
        <div class="col-3">{{ 'INFO.BUSINESS_TYPE' | translate | uppercase }}</div>
        <div class="col-9">{{businessTypesString}}</div>
      </div>
      <div *ngIf="!loading" class="row info">
        <div class="col-3">{{ 'INFO.ADDRESS' | translate | uppercase }}</div>
        <div class="col-9">{{venueItem?.formatedAddress}}</div>
      </div>
      <div *ngIf="!loading" class="row info">
        <div class="col-6">{{ 'LOGIN.EMAIL' | translate | uppercase }}</div>
        <div class="col-6">{{venueItem?.email}}</div>
      </div>
      <div *ngIf="!loading" class="row info">
        <div class="col-6">{{ 'LOGIN.PHONE' | translate | uppercase }}</div>
        <div class="col-6">{{venueItem?.phone}}</div>
      </div>
      <div *ngIf="!loading" class="row info">
        <div class="col-4">{{ 'VENUES.GUEST_CAPACITY' | translate | uppercase }}</div>
        <div class="col-8">{{venueItem?.maximumCapacity}}</div>
      </div>
      <div *ngIf="!loading" class="row">
        <!-- <div class="col-6">
          <div style="justify-content: space-between;" class="d-flex flex-row label-info">
            <label style="margin-top: 8px;" for="administrator">{{ 'VENUES.ASSIGNED_ADMIN' | translate | uppercase }}</label>
          </div>
          <div></div>
        </div> -->
        <div class="col-12">
          <div style="justify-content: space-between;" class="d-flex flex-row label-info">
            <label style="margin-top: 8px;" for="hosts">{{ 'VENUES.ASSIGNED_HOSTS' | translate | uppercase }}</label>
          </div>
          <div style="max-height: 60px; overflow: auto; " >
            <div *ngFor="let host of hostList" class="d-flex flex-row align-items-center host-item"><mat-icon class="icon">person</mat-icon>&nbsp;{{host.firstName}}&nbsp;{{host.lastName}}</div>
          </div>
          <div></div>
        </div>
      </div>
      <div *ngIf="loading" class="row info">
        <mat-spinner style="margin-top: 80px; margin-bottom: 80px;" class="api-data-spinner"></mat-spinner>
      </div>
      <div *ngIf="!loading" style="margin-top: 32px;" class="row">
        <div class="col-12">
          <div class="d-flex" style="border-bottom: 1px solid #00ffff; justify-content: space-between;">
            <label style="width: 50%; margin-top: 0px; border: none" for="address">{{ 'VENUES.PHOTO_GALLERY' | translate | uppercase }}</label>
          </div>
          <div class="gallery-container d-flex flex-row">
            <div *ngFor="let image of images; let i = index" class="gallery-item">
              <img
                id="image-{{i}}"
                [src]="serverImages[i] ? serverImages[i] : './assets/images/icons/venue-logo-placeholder-01.svg'"
                alt="venue-placeholder"
              >
              <div style="left: 45px;" *ngIf="serverImages[i]" class="actions d-flex">
                <mat-icon (click)="showLightbox(i)">remove_red_eye</mat-icon>
              </div>
            </div>
          </div>
        </div>
      </div>

    </mat-step>
  </mat-horizontal-stepper>
</mat-dialog-content>
<ng-image-fullscreen-view
    [images]="imagesObject"
    [imageIndex]="selectedImageIndex"
    [show]="showFlag"
    (close)="closeImageViewer()"></ng-image-fullscreen-view>
